import CipherIcon from "./CipherIcon";
import ClientService from "./ClientService";
import DisplayOtp from "./DisplayOtp";
import PageHeader from "./PageHeader";
import UploadFile from "./UploadFile";
import GenerateOptions from "./GenerateOptions";
import ItemInput from "./ItemInput";
import UserAvatar from "./UserAvatar";
import AuthLogo from "./AuthLogo";
import DataNotFound from "./DataNotFound";
import NoticeCards from "./NoticeCards";

const commonComponents = {
  CipherIcon,
  ClientService,
  DisplayOtp,
  PageHeader,
  UploadFile,
  GenerateOptions,
  ItemInput,
  UserAvatar,
  AuthLogo,
  DataNotFound,
  NoticeCards
}

export default commonComponents